import React from 'react';
import QualityScore from '../QualityScore';
import AlertsPanel from '../AlertsPanel';
import ConsistencyPanel from '../ConsistencyPanel';
import WorkflowButtons from '../WorkflowButtons';

/**
 * Seção com score de qualidade, workflow e alertas
 * @param {object} scoreQualidade - Score de qualidade da NC
 * @param {string} versaoAnalise - Versão da análise
 * @param {array} alertas - Lista de alertas
 * @param {number} ncId - ID da NC
 * @param {string} currentStatus - Status atual do workflow
 * @param {object} user - Dados do usuário
 * @param {function} onStatusChange - Callback para mudança de status
 */
function NCResultScoreSection({
  scoreQualidade,
  modoAnalise,
  avisosConsistencia,
  versaoAnalise,
  alertas,
  ncId,
  currentStatus,
  user,
  onStatusChange,
  analiseVazia
}) {
  return (
    <div className="v2-section">
      <div className="v2-left">
        {/* Registro não recebe nota (Sessão 40): só Investigação mostra o score */}
        {modoAnalise !== 'registro' && (
          <QualityScore score={scoreQualidade} versaoAnalise={versaoAnalise} />
        )}
        <WorkflowButtons
          ncId={ncId}
          currentStatus={currentStatus}
          onStatusChange={onStatusChange}
          user={user}
          analiseVazia={analiseVazia}
        />
      </div>
      <div className="v2-right">
        <AlertsPanel alertas={alertas} />
        {/* Sessão 41 (C-A/C-B) — sinais soft de consistência (só Investigação;
            some quando vazio). Distinto das Validações: NÃO afeta a nota. */}
        <ConsistencyPanel avisos={avisosConsistencia} />
      </div>
    </div>
  );
}

export default NCResultScoreSection;